import { HttpErrorResponse, HttpInterceptorFn } from '@angular/common/http';
import { throwError } from 'rxjs';
import { catchError, tap } from 'rxjs/operators';
import { inject } from '@angular/core';
import { AccountService } from 'services/account.service';

const UNAUTHORIZED_RESPONSE_CODE = 401;
const UNAUTHORIZED_RESPONSE_CODE_DEPRECATED = 'NOT_AUTHENTICATED';
const UNAUTHORIZED_RESPONSE_CODE_KEY = 'descriptionCode';

export const authInterceptor: HttpInterceptorFn = (request, next) => {
  const accountService = inject(AccountService);

  return next(request).pipe(
    // Not authenticated error handling for v0 endpoints
    tap((response: any) => {
      const responseCode = response.body && response.body[UNAUTHORIZED_RESPONSE_CODE_KEY];

      if (responseCode === UNAUTHORIZED_RESPONSE_CODE_DEPRECATED) {
        accountService.login();
      }
    }),
    // Not authenticated error handling for v1 endpoints
    catchError((response: HttpErrorResponse) => {
      if (response.status === UNAUTHORIZED_RESPONSE_CODE) {
        accountService.login();
      }
      return throwError(response);
    })
  );
};
